/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from 'react';
import { makeStyles } from 'src/makeStyles';
import PropTypes from 'prop-types';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import SocialShareBlock from '../SocialShareBlock';
import { buildSocialLinks } from '../../utils/common';
import { colors } from '../../constants/styleConstants';
import usePrivacyAttributes from '../../utils/privacy';

const useStyles = makeStyles()((theme, props) => ({
  socialLinksBlock: {
    display: 'flex',
    marginTop: '10px',
    flexDirection: props?.showContact ? 'row' : 'column',
  },
  iconClass: {
    width: '40px !important',
    height: '40px !important',
    [theme.breakpoints.up('md')]: {
      marginRight: 8,
      marginBottom: 8,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 2,
      marginBottom: 5,
      width: '35px !important',
      height: '35px !important',
    },
  },
  contactIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    padding: '10px',
    borderRadius: '50%',
    background: colors.darkText,
    cursor: 'pointer',
    marginRight: '15px',
    color: 'white',
    filter: 'drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.137784))',
    [theme.breakpoints.down('md')]: {
      marginRight: '8px',
      width: '35px',
      height: '35px',
    },
  },
  contactIcon: {
    width: 25,
    [theme.breakpoints.between(0, 600)]: {
      width: 20,
    },
  },
  followText: {
    color: '#5f5f5f',
    fontSize: 12,
    opacity: 0.5,
    [theme.breakpoints.up('md')]: {
      paddingBottom: 10,
    },
  },
}));

const StubPageSocialLinks = ({ contacts, showContact, showContactsTab, socialLinksTitle }) => {
  const { classes, cx } = useStyles({ showContact });
  const { canSee } = usePrivacyAttributes();

  const socialLinks = useMemo(() => buildSocialLinks(contacts.filter(contact => canSee(contact?.privacyAttributes))), [
    canSee,
    contacts,
  ]);

  return (
    <div className={classes.socialLinksBlock}>
      {!showContact && socialLinks?.length > 0 && <div className={classes.followText}>{socialLinksTitle}</div>}
      {showContact && (
        <div onClick={showContactsTab} className={classes.contactIconContainer}>
          <ContactMailIcon className={classes.contactIcon} />
        </div>
      )}
      {contacts?.length > 0 && <SocialShareBlock socialLinks={socialLinks} className={classes.iconClass} />}
    </div>
  );
};

StubPageSocialLinks.propTypes = {
  contacts: PropTypes.array,
  showContact: PropTypes.bool,
  showContactsTab: PropTypes.func,
  socialLinksTitle: PropTypes.string,
};

export default StubPageSocialLinks;
